// MODULES
import React from "react";

// HELPERS
import {createClassName} from "@helpers/utils";
import fulfillmentCheck from "./Fees.fulfillment";
import DefaultFields from "../../../../components/DefaultFields/DefaultFields";
import EditableField from "../../../../components/EditableField/EditableField";
import FieldsCollection from "../../../../../../components/FieldsCollection/FieldsCollection";
import * as CobHelpers from "../../../../Cob.helpers";
import NumberField from "../../../../components/NumberField/NumberField";
import {delay, getPropertiesByPrefix, parseDraftDataPropsToFieldState} from "../../../../../../helpers/utils";

export default class Fees extends React.PureComponent
{
    static companyExclusive = false;
    static privateExclusive = false;

    static fields = _getFields();
    state = _getInitialState.call(this);

    componentDidUpdate(prevProps, prevState)
    {
        const {props, state} = this;
        const {id, onChange} = props;

        if (prevState.fields !== state.fields)
        {
            onChange(id, {...state}, fulfillmentCheck(props, state));
        }

        if (prevProps.draftData !== props.draftData)
        {
            if (props.draftData)
            {
                // get the draftData props specific to this section only
                const draftDataProps = getPropertiesByPrefix(props.draftData, ["futur_fee_"]);
                // parse the draftData props into state.fields
                const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);

                newFieldsState.futur_fee_premie = newFieldsState.futur_fee_premie.replace("%", "");
                newFieldsState.futur_fee_premie = newFieldsState.futur_fee_premie.replace(",", ".");
                newFieldsState.futur_fee_premie = newFieldsState.futur_fee_premie.replace(".00", "");

                newFieldsState.futur_fee_kapital = newFieldsState.futur_fee_kapital.replace("%", "");
                newFieldsState.futur_fee_kapital = newFieldsState.futur_fee_kapital.replace(",", ".");
                newFieldsState.futur_fee_kapital = newFieldsState.futur_fee_kapital.replace(".00", "");

                this.setState({fields: {...newFieldsState}},
                    async () =>
                    {
                        await delay(200);
                        onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
                    }
                );
            }
        }
    }

    render()
    {
        const {props, state} = this;
        const {title} = props;

        const classes = createClassName("Cob-Fees", {
            "Cob-View": true,
            "fulfilled": state.isFulfilled
        });

        return (
            <div className={classes}>
                <DefaultFields fields={this.constructor.fields} />

                <div className="Cob-Fields">
                    <h2>{title}</h2>

                    <FieldsCollection
                        fieldsPerRow={3}
                        fields={[
                            {
                                render: (
                                    <EditableField
                                        name="futur_fee_premie"
                                        Component={NumberField}
                                        label="Premieavgift"
                                        value={state.fields.futur_fee_premie}
                                        valid={state.validFields.futur_fee_premie}
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        unit={"%"}
                                        decimalSeparator={","}
                                        required
                                    />
                                )
                            }, {
                                render: (
                                    <EditableField
                                        name="futur_fee_kapital"
                                        Component={NumberField}
                                        label="Kapitalavgift"
                                        value={state.fields.futur_fee_kapital}
                                        valid={state.validFields.futur_fee_kapital}
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        unit={"%"}
                                        decimalSeparator={","}
                                        required
                                    />
                                )
                            }
                        ]}
                    />

                    {state.fields.futur_fee_kapital.length > 0 && state.fields.futur_fee_kapital > 0 && state.fields.futur_fee_kapital < 0.25 && (
                        <p>
                            <strong style={{color: "red"}}>Obs!</strong>
                            Kapitalavgiften understiger 0,25% vilket kommer leda till att
                            ansökan måste granskas manuellt av Futur innan godkännande.
                        </p>
                    )}

                    {state.fields.futur_fee_kapital.length > 0 && state.fields.futur_fee_kapital > 1.5 && (
                        <p>
                            <strong style={{color: "red"}}>Obs! </strong>
                            Kapitalavgiften överstiger max tillåtna 1,5%.
                        </p>
                    )}

                </div>
            </div>
        );
    }

    _fieldValidator = (name, value) =>
    {
        if (name === "futur_fee_kapital")
        {
            return value.length > 0 && value <= 1.5 && value > 0;
        }

        return value.length > 0;
    };

    _onFieldChange = (name, value) =>
    {
        CobHelpers.onViewFieldChange.call(this, name, value);
    };

    _onFieldBlur = (name) =>
    {
        CobHelpers.onViewFieldBlur.call(this, name);
    };
}

function _getFields()
{
    return [
        "futur_fee_premie",
        "futur_fee_kapital"
    ];
}

function _getInitialState()
{
    if (this.props.prevState)
    {
        return {...this.props.prevState};
    }

    return {
        validFields: {},
        fields: {
            futur_fee_premie: "",
            futur_fee_kapital: ""
        }
    };
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Fees/Citroneer/Fees.js